import { render } from "./ValueAddedTreaSure.vue?vue&type=template&id=3a7fec62"
import script from "./ValueAddedTreaSure.vue?vue&type=script&lang=js"
export * from "./ValueAddedTreaSure.vue?vue&type=script&lang=js"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__